(function () {
  function init() {
    const modal      = document.getElementById('external-link-modal');
    const backdrop   = document.getElementById('external-link-backdrop');
    const modalWindow = document.getElementById('external-modal-window');
    const closeBtn   = document.getElementById('external-modal-close');
    const confirmBtn = document.getElementById('external-modal-confirm-btn');

    if (!modal) return;

    const TARGET_URL = 'https://support.coros.com/hc/es';

    function openModal() {
      modal.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function attachListener() {
      document.querySelectorAll(`a[href="${TARGET_URL}"]`).forEach(function (link) {
        if (link.dataset.externalModalBound) return;
        link.dataset.externalModalBound = 'true';
        link.addEventListener('click', function (e) {
          e.preventDefault();
          openModal();
        });
      });
    }

    attachListener();

    const observer = new MutationObserver(attachListener);
    observer.observe(document.body, { childList: true, subtree: true });

    confirmBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeModal();
      window.open(TARGET_URL, '_blank', 'noopener,noreferrer');
    });

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function (e) {
      if (!modalWindow.contains(e.target)) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();